import React from 'react';

import { CharacterCounter } from '@admin/components/character_counter';

import { SMS_CONSTANTS } from './constants';
import { canUpdateCxInbox } from './permissions';
import { PhoneWithName } from './types';
import { getPhoneOptionLabel } from './utils';

interface MessageFormProps {
  messageBody: string;
  setMessageBody: (body: string) => void;
  smsEnabled: boolean;
  placeholder: string;
  loadingState: { sendingMessage: boolean };
  phoneList: PhoneWithName[];
  phoneToSendTo?: PhoneWithName;
  setPhoneToSendTo: (phone: PhoneWithName | undefined) => void;
  hasMultiplePhones: boolean;
  recipientType: 'Account' | 'Lead';
  onSendMessage: () => void;
}

export const MessageForm: React.FC<MessageFormProps> = ({
  messageBody,
  setMessageBody,
  smsEnabled,
  placeholder,
  loadingState,
  phoneList,
  phoneToSendTo,
  setPhoneToSendTo,
  hasMultiplePhones,
  recipientType,
  onSendMessage,
}) => {
  if (!canUpdateCxInbox()) {
    return null;
  }

  const canSendMessage = () => {
    const trimmedBody = messageBody.trim();
    return (
      trimmedBody.length > 0 &&
      trimmedBody.length <= SMS_CONSTANTS.MAX_LENGTH &&
      !loadingState.sendingMessage &&
      smsEnabled &&
      phoneToSendTo !== undefined
    );
  };

  return (
    <>
      <h4>
        New Message
        {hasMultiplePhones && smsEnabled && (
          <>
            {' to '}
            <select
              data-test-id="message-form-phone-select"
              value={phoneToSendTo?.id ? String(phoneToSendTo.id) : ''}
              onChange={(e) => {
                const value = e.target.value;
                const selected = phoneList.find((p) => String(p.id) === value);
                setPhoneToSendTo(selected || undefined);
              }}
            >
              {phoneList.map((phone) => (
                <option key={phone.id} value={phone.id}>
                  {getPhoneOptionLabel(phone)}
                </option>
              ))}
            </select>
          </>
        )}
      </h4>

      <h5>Warning: Customers can see what you send from here!</h5>

      <div className="form-group">
        <textarea
          className="form-control"
          maxLength={SMS_CONSTANTS.MAX_LENGTH}
          name="message-body"
          placeholder={placeholder}
          value={messageBody}
          onChange={(e) => setMessageBody(e.target.value)}
          disabled={!smsEnabled}
        />
      </div>
      <div className="form-group text-right">
        <CharacterCounter characterCount={messageBody.length} characterLimit={SMS_CONSTANTS.MAX_LENGTH} />
        <button type="button" disabled={!canSendMessage()} className="btn btn-primary" onClick={onSendMessage}>
          {loadingState.sendingMessage ? 'Sending...' : 'Send SMS'}
        </button>
      </div>
    </>
  );
};
